import React from 'react';
import { useNavigate } from 'react-router-dom';

import FormItem from './FormItem';

export default function Request() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/leave');
  };

  return (
    <div className="p-16 w-100 h-100">
      <div className="leave">
        <div className="leave-content">
          <h2>Request Leave</h2>
          <div>
            <FormItem
              type="select"
              name="category"
              label="Leave category"
              placeholder="Select..."
              required
            >
              <option value="Annual Leave">Annual Leave</option>
              <option value="Sick Leave">Sick Leave</option>
            </FormItem>

            <FormItem
              type="date"
              name="from"
              label="From"
              placeholder="From"
              required
            />

            <FormItem
              type="date"
              name="to"
              label="To"
              placeholder="To"
              required
            />

            <FormItem
              type="text"
              name="comment"
              label="Comment"
              placeholder="Comment"
            />
          </div>
        </div>
        <div className="leave-footer">
          <div className="leave-footer-buttons">
            <button type="button" className="btn" disabled>Submit</button>
            <button type="button" className="btn btn-outline" onClick={handleBack}>Back</button>
          </div>
        </div>
      </div>
    </div>
  );
}
